import {Injectable} from '@angular/core';

import { ClientSettingsService } from './ClientSettingsService';

@Injectable()
export class SecretService {

  constructor(private clientSettingsService: ClientSettingsService) {}

  public get adalConfig(): any {
    return { 

      //if clientSettingsService instance, clientId or cacheLocation is set in app.componect.ts then 
      //use them. If not use defaults for EngWeb. This makes code backward compatible. 
      instance: this.clientSettingsService.instance != undefined ? this.clientSettingsService.instance : 'https://adfstest.micron.com/',
      tenant: 'adfs',
      clientId: this.clientSettingsService.clientId != undefined ? this.clientSettingsService.clientId : 'dc637fa9-82d8-4f7a-97d0-851422fc12ff',
      redirectUri: window.location.origin + this.clientSettingsService.RedirectUrlSuffix,
      postLogoutRedirectUri: window.location.origin + this.clientSettingsService.RedirectUrlSuffix,
      cacheLocation: this.clientSettingsService.cacheLocation != undefined ? this.clientSettingsService.cacheLocation : null,
      expireOffsetSeconds: this.clientSettingsService.expireOffsetSeconds != undefined ? this.clientSettingsService.expireOffsetSeconds : 60

    };
  }
}
